
const __default__ = {
  props: {
    title: {
      type: String,
      required: true
    },
    padding: {
      type: String,
      default: '0 1.6rem'
    },
    initial: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false
    }
  },
  mounted() {
    this.open = this.initial
  },
  methods: {
    openMenu() {
      this.open = !this.open
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "6bb10802-padding": (_ctx.padding)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__